module.exports = __webpack_public_path__ + "img/step00_bg.3892a33f.jpg";